import React, { useState, useEffect } from 'react';
import { IconPlus, IconSearch, IconX } from '@tabler/icons-react';
import axios from 'axios';
import Avatar from '@mui/material/Avatar';
import { useAuth } from '../../../Context/store/context';
import globals from '../../../../globals';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CreateUserForm from './CreateUserForm';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Customer from './Customer';
import Adminchangepassword from './Adminchangepassword';
import Viewpackages from './Viewpackages';

const CustomerD = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isDialogOpenview, setIsDialogOpenview] = useState(false);
    const [isDialogForGot, setIsDialogForGot] = useState(false);
    const [isDialogPackage, setIsDialogPackage] = useState(false);
    const [roolSection, setRoolSection] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [editUserData, setEditUserData] = useState(null);
    const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();

    useEffect(() => {
        if (!getToken()) logoutuser();
        updateTitleAndIcon(globals.Customer.title, globals.Customer.icon);
        fetchRools();
    }, []);

    const fetchRools = async () => {
        try {
            const response = await axios.get(`http://localhost:4000/getuserdata`);
            setRoolSection(response.data.userdata);
            setFilteredData(response.data.userdata);
        } catch (error) {
            console.error('Error fetching rools:', error);
        }
    };
  
    const searchHandler = () => {
        const filtered = roolSection.filter(item =>
            item.firstName.toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilteredData(filtered);
    };

    const resetHandler = () => {
        setSearchValue("");
        setFilteredData(roolSection);
    };

    const toggleDialog = () => {
      const selectedUser = roolSection.find(user => user.userId === selectedUserId);
    console.log("Editing user:", selectedUser);
    setEditUserData(selectedUser);
        setIsDialogOpen(true);
    };
    const toggleDialogPassword = () => {
      const selectedUser = roolSection.find(user => user.userId === selectedUserId);
      console.log("Editing user:", selectedUser);
      setEditUserData(selectedUser);
    setIsDialogForGot(true);
    };
    const toggleDialogPackage = () => {
      const selectedUser = roolSection.find(user => user.userId === selectedUserId);
      console.log("Editing user:", selectedUser);
      setEditUserData(selectedUser);
      setIsDialogPackage(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
        setIsDialogOpenview(false);
        setIsDialogForGot(false);
        setIsDialogPackage(false);
        fetchRools();
    };

    const handleMenuOpen = (event, userId) => {
        setAnchorEl(event.currentTarget);
        setSelectedUserId(userId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedUserId(null);
    };

    const handleViewUser = () => {
        setIsDialogOpenview(true);
        handleMenuClose();
    };

    const handleDeleteUser = async() => {
      try{
        console.log("Deleting user:", selectedUserId);
        const response = await axios.delete(`http://localhost:4000/getuserdelete/${selectedUserId}`);
        console.log(response.data.message);
        fetchRools();
      } catch (error) {
        console.error('Error deleting role:', error);
      }
        handleMenuClose();
    };
    const handleToggleState = async () => {
      try {
        const currentState = roolSection.find(user => user.userId === selectedUserId)?.state;
        const newState = currentState === 'Activate' ? 'De Activate' : 'Activate';
    
        await axios.put(`http://localhost:4000/update-user/${selectedUserId}`, {
          state: newState,
          updateDate: new Date()
        });
    
        fetchRools(); // Refresh data
      } catch (error) {
        console.error('Error updating state:', error);
      }
      handleMenuClose();
    };
    
  
  
    return (
        <div>
          <div className="content-wrapper">
<div className="container-xxl flex-grow-1 container-p-y">
  <div className="d-flex flex-column gap-0 mp-2 rounded justify-content-center align-items-center">
    <div className="w-100">
    <div className="w-100 gap-4 gap-md-0 justify-content-start row">
{/* Total Members */}
<div className="fotoowl-plan col-md-6 col-xl-3">
  <div className="main-card h-100 position-relative card">
    <div className="px-1 px-md-3 card-body text-center">
      <div>
        <h4><strong>{roolSection.length}</strong></h4>
        <p><strong className='text-primary'>Total customers</strong></p>
      </div>
    </div>
  </div>
</div>

{/* Admins */}
<div className="fotoowl-plan col-md-6 col-xl-3">
  <div className="main-card h-100 position-relative card">
    <div className="px-1 px-md-3 card-body text-center">
      <div>
        <h4>
          <strong>
            {
              roolSection.filter(user => {
                const today = new Date();
                const registeredDate = new Date(user.RegistedDate);
                const timeDiff = today - registeredDate;
                const daysSinceRegistered = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                return daysSinceRegistered <= 7 && daysSinceRegistered >= 0;
              }).length
            }
          </strong>
        </h4>
        <p><strong className='text-primary'>New customer (last 7 days)</strong></p>
      </div>
    </div>
  </div>
</div>


{/* Users */}
<div className="fotoowl-plan col-md-6 col-xl-3">
  <div className="main-card h-100 position-relative card">
    <div className="px-1 px-md-3 card-body text-center">
      <div>
        <h4>
          <strong>
            {
              roolSection.filter(user => {
                const today = new Date();
                const expiryDate = new Date(user.Packageexpire);
                const timeDiff = expiryDate - today;
                const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                return daysRemaining > 0 && daysRemaining <= 30;
              }).length
            }
          </strong>
        </h4>
        <p><strong className='text-primary'>About expire (less than 30 days)</strong></p>
      </div>
    </div>
  </div>
</div>
<div className="fotoowl-plan col-md-6 col-xl-3">
  <div className="main-card h-100 position-relative card">
    <div className="px-1 px-md-3 card-body text-center">
      <div>
        <h4>
          <strong>
            {
              roolSection.filter(user => {
                const today = new Date();
                const packageExpireDate = new Date(user.Packageexpire);
                return packageExpireDate < today; // Count users whose package has expired
              }).length
            }
          </strong>
        </h4>
        <p><strong className='text-primary'>Expired</strong></p>
      </div>
    </div>
  </div>
</div>

</div>

    
    </div>
  </div>
</div>
</div>
            <div className="card mb-3">
                <div className="card-body d-flex align-items-center flex-wrap">
                    <div className="flex-grow-1 d-flex flex-wrap">
                        <div className="flex-grow-1 search me-1">
                            <div className="search-input-wrap w-100 md-w-75">
                                <input 
                                    className="search-input w-100 p-2" 
                                    placeholder="Search by first name" 
                                    value={searchValue} 
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                                <IconX size={16} className="search-clear" onClick={resetHandler} />
                            </div>
                            <button className="btn btn-soft-primary search-btn me-1" onClick={searchHandler}>
                                <IconSearch size={16} />
                            </button>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={toggleDialog}>
                        <IconPlus className="me-sm-1 me-0" size={20} /> Create Customer
                    </button>
                </div>
            </div>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">#ID</TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="left">Mobile Number</TableCell>
                            <TableCell align="left">Registered Date</TableCell>
                            <TableCell align="left">Package Created</TableCell>
                            <TableCell align="left">Package Expire</TableCell>
                            <TableCell align="left">state</TableCell>
                            <TableCell align="left">Created By</TableCell>
                            <TableCell align="left">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredData.map((row) => (
                            <TableRow key={row.userId}>
                                <TableCell align="left">{row.userId}</TableCell>
                                <TableCell align="left">
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <Avatar sx={{ width: 32, height: 32, fontSize: "14px" }}>
                                            {row.firstName?.charAt(0).toUpperCase()}{row.lastName?.charAt(0).toUpperCase()}
                                        </Avatar>
                                        <span style={{ fontSize: "14px" }}>{row.firstName} {row.lastName}</span>
                                    </div>
                                </TableCell>
                                <TableCell align="left">{row.email}</TableCell>
                                <TableCell align="left">{row.contactNo || row.phoneNumber}</TableCell>
                                <TableCell align="left">{row.RegistedDate}</TableCell>
                                <TableCell align="left">{row.PackageCreated}</TableCell>
                                <TableCell align="left">{row.Packageexpire}</TableCell>
                                <TableCell align="left" style={{ color: row.state === 'Activate' ? 'green' : 'red' }}>
  {row.state}
</TableCell>


                                <TableCell align="left">{row.createdby || "Admin"}</TableCell>
                                <TableCell align="left">
                                    <IconButton onClick={(event) => handleMenuOpen(event, row.userId)}>
                                        <MoreVertIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={handleViewUser}>View</MenuItem>
                <MenuItem onClick={()=>{
                  handleMenuClose()
                  toggleDialog()
                }}>Edit</MenuItem>
                <MenuItem onClick={()=>{
                  handleMenuClose()
                  toggleDialogPassword()
                }}>Reset Password</MenuItem>
                <MenuItem onClick={()=>{
                  handleMenuClose()
                  toggleDialogPackage()
                }}>Add package</MenuItem>
                <MenuItem onClick={handleToggleState}>
  {roolSection.find(user => user.userId === selectedUserId)?.state === 'Activate'
    ? 'Deactivate'
    : 'Activate'}
</MenuItem>
                <MenuItem onClick={handleDeleteUser}>Delete</MenuItem>
            </Menu>
            
            {isDialogOpenview && <Customer name={roolSection} onClose={closeDialog} />}
            {isDialogForGot && <Adminchangepassword  name={editUserData} onClose={closeDialog} />}
            {isDialogOpen && <CreateUserForm name={editUserData} onClose={closeDialog} />}
            {isDialogPackage && <Viewpackages name={editUserData} onClose={closeDialog} />}
        </div>
    );
};

export default CustomerD;